/**
 *  This is our Axios configuration and start of the connection.
 *  It checks local storage to see if there is a JWT token present for future API calls.
 *  Our backend applications use JWT authentication and most calls will require this to be set.
 *
 *  We can also set which headers are required. This will feed into our other api calls which are
 *  separated into different files for easy managment and readiibility
 */

import axios from 'axios';
import Store from '@/store/store';

axios.defaults.withCredentials = true;

export default () => {
 
  const thisAxios = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });

  // check for any 401 - Unauthorized responses and kick to login url
  thisAxios.interceptors.response.use((response) => {
    return response;
  }, (error) => {  
    if (401 === error.response.status) {  
      // on LIVE
      window.location.href = Store.getters['app/urls'].login;

    } else {
      return Promise.reject(error);
    }    
  });

  return thisAxios;
};
